<template>
  <v-card flat color="transparent">
    <v-toolbar flat
      color="transparent">
      <v-toolbar-title v-if="$vuetify.breakpoint.smAndUp" class="body-1">{{ isEmpty ? '' : printLabel }}</v-toolbar-title>
      <v-select v-else v-model="form.id"
        :label="isEmpty ? '申込がありません' : printLabel"
        :items="getItems"
        item-text="text"
        item-value="value"
        :disabled="isLoading"
        class="mt-4"
        @change="select"
      />
      <div class="flex-grow-1" />
      <v-menu bottom left offset-y>
        <template v-slot:activator="{ on }">
          <v-btn depressed
            v-on="on"
            color="secondary"
            :loading="isLoading"
          >
            <v-icon small>fa-cog</v-icon>{{ $vuetify.breakpoint.smAndUp ? '&nbsp;機能' : '' }}
          </v-btn>
        </template>
        <v-list>
          <v-list-item @click.stop="$refs.programer.open()">
            <v-list-item-avatar>
              <v-icon small>fal fa-plus</v-icon>
            </v-list-item-avatar>
            <v-list-item-content>
              <v-list-item-title>申込を追加する</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item v-if="isSet" @click.stop="$refs.programer.open({ type: 'update', item: $props.item })">
            <v-list-item-avatar>
              <v-icon small>fal fa-undo</v-icon>
            </v-list-item-avatar>
            <v-list-item-content>
              <v-list-item-title>{{ isPublished ? '申込を再編集する' : '申込を編集する'}}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item v-if="isSet && !isPublished" @click.stop="$refs.publisher.open()">
            <v-list-item-avatar>
              <v-icon small>fal fa-envelope-open-text</v-icon>
            </v-list-item-avatar>
            <v-list-item-content>
              <v-list-item-title>申込書を発行する</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item v-if="isSet && isPublished" @click.stop="$refs.publisher.open($props.item)">
            <v-list-item-avatar>
              <v-icon small>fal fa-copy</v-icon>
            </v-list-item-avatar>
            <v-list-item-content>
              <v-list-item-title>申込書を再発行する</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
        <v-divider v-if="isSet && !isPublished"></v-divider>
        <v-list v-if="isSet && !isPublished">
          <v-list-item class="red--text" @click.stop="remove">
            <v-list-item-avatar>
              <v-icon small>fal fa-trash-alt</v-icon>
            </v-list-item-avatar>
            <v-list-item-content>
              <v-list-item-title>この申込を削除する</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-menu>
      <template v-slot:extension
        v-if="$vuetify.breakpoint.smAndUp && !isEmpty">
        <v-tabs grow
          v-model="store.tabPos"
          background-color="transparent"
          color="secondary">
          <v-tab v-for="item in getItems" :key="item.value"
            @click="select(item.value)">{{ item.text }}</v-tab>
        </v-tabs>
      </template>
    </v-toolbar>
    <v-divider v-if="$vuetify.breakpoint.smAndUp && !isEmpty" class="mb-4"></v-divider>
    <ProgramModal ref="programer" @done="insert"></ProgramModal>
    <PublishModal ref="publisher" :item="getItem" @done="insert"></PublishModal>
    <Confirmer ref="confirmer" />
  </v-card>
</template>
<script>
import ProgramModal from './modals/program'
import PublishModal from './modals/publish'
import Confirmer from '@/components/modals/confirm'
export default {
  name: 'clientApplyToolbar',
  components: {
    ProgramModal,
    PublishModal,
    Confirmer
  },
  props: [
    'item'
  ],
  data () {
    return {
      config: {
        status: {
          loading: false
        }
      },
      form: {
        id: ''
      },
      store: {
        items: [],
        tabPos: null
      }
    }
  },
  watch: {
    'store.items.length' (val) {
      this.store.tabPos = val - 1
    }
  },
  mounted () {
    this.get(this.$route.query.id)
  },
  methods: {
    get: function (appId) {
      const cid = this.$route.params.id
      this.$set(this.config.status, 'loading', true)
      this.$firebase.auth().currentUser.getIdToken(true).then(token => {
        this.axios.post(`${this.$url.api}apply/get/items/${cid}`, {}, {
          headers: {
            'firebase-token': token
          }
        }).then(res => {
          console.log(res)
          this.$set(this.config.status, 'loading', false)
          if (res.data && res.data.success) {
            let items = res.data.data
            this.$set(this.store, 'items', items)
            this.$set(this.form, 'id', appId || (items.length ? items[items.length - 1].id : ''))
            this.select()
          }
        })
      }).catch(err => {
        console.log(err)
        this.$set(this.config.status, 'loading', false)
      })
    },
    select: function (id) {
      if (id) {
        this.$set(this.form, 'id', id)
      }
      this.$nextTick(() => {
        let idx = this.store.items.findIndex(it => { return it.id === this.form.id })
        if (idx >= 0) {
          this.$emit('select', this.store.items[idx])
        } else {
          this.$emit('select', this.store.items.length ? this.store.items[0] : {})
        }
      })
    },
    insert: function (item) {
      let idx = this.store.items.findIndex(it => { return it.id === item.id })
      if (idx >= 0) {
        this.store.items.splice(idx, 1, item)
      } else {
        this.store.items.push(item)
      }
      this.$nextTick(() => {
        this.select(item.id)
      })
    },
    remove: function () {
      let aid = this.form.id
      if (aid) {
        this.$refs.confirmer.open({
          message: '本当にこの申込を削除してもよろしいですか？',
          callback: () => {
            this.$set(this.config.status, 'loading', true)
            this.$firebase.auth().currentUser.getIdToken(true).then(token => {
              this.axios.post(`${this.$url.api}apply/delete/item/${aid}`, {
                cid: this.$route.params.id
              }, {
                headers: {
                  'firebase-token': token
                }
              }).then(res => {
                console.log(res)
                this.$set(this.config.status, 'loading', false)
                if (res.data && res.data.success) {
                  let idx = this.store.items.findIndex(it => { return it.id === aid })
                  if (idx >= 0) {
                    this.store.items.splice(idx, 1)
                  }
                  this.$set(this.form, 'id', this.store.items.length ? this.store.items[0].id : '')
                  this.select()
                }
              })
            })
          }
        })
      }
    }
  },
  computed: {
    isLoading () {
      return this.config.status.loading
    },
    isEmpty () {
      return this.store.items.length === 0
    },
    isSet () {
      return !!(this.$props.item && this.$props.item.id)
    },
    printLabel () {
      if (this.$props.item) {
        let item = this.$props.item
        return [
          (item.country && this.$mango.nations[item.country]) ? ('【国】' + this.$mango.nations[item.country]) : '',
          item.city ? ('【市】' + item.city) : ''
        ].join(' ')
      } else {
        return '申込一覧'
      }
    },
    isPublished () {
      return (this.$props.item && this.$props.item.published_at && this.$props.item.published_at !== '0000-00-00 00:00:00')
    },
    isRequiredRepublish () {
      return (
        this.$props.item &&
        this.$props.item.media &&
        this.$props.item.modified_at &&
        this.$props.item.published_at &&
        this.$props.item.published_at !== this.$props.item.modified_at
      )
    },
    getItem () {
      return this.$props.item ? this.$props.item : {}
    },
    getItems () {
      return this.store.items.map(it => {
        return {
          text: (it.published_at && it.published_at !== '0000-00-00 00:00:00') ? `【確定】${it.title}` : (it.status === 4 ? `【要確認】${it.title}` : it.title),
          value: it.id
        }
      })
    }
  }
}
</script>
